import * as Cookies from "js-cookie";
import React from 'react'

// max cookie size is 4096 bytes so keep this to a min
export const setSessionCookie = (session) => {
  const truncSession = {
    profile: session.profile,
    photo: session.photo,
    firstName: session.firstName,
    userName: session.userName,
    lastName: session.lastName,
    studentType: session.studentType,
    college: session.college,
    organization: session.organization,
    email: session.email,
    dateOfBirth: session.dateOfBirth,
    phone: session.phone,
    companyId: session.companyId,
    timestamp: session.timestamp,
    jwt: session.jwt,
  }
  Cookies.set("session", truncSession, { expires: 14 });
};

export const clearSessionCookie = () => {
  Cookies.remove("session");
};

export const isAmbassador = () => {
  if (window.location.href.endsWith('/partners')) {
    return true;
  }
};


export const isMentor = (session) => {
  return session.studentType === "CURRENT"
};

export const isMentee = (session) => {
  return session.studentType === "PROSPECTIVE"
};

export const isLoggedIn = () => {
  const sessionCookie = Cookies.get("session");

  if (!sessionCookie) {
    return false;
  }

  if (window.location.href.endsWith('/partners')) {
    return false;
  }

  const jsonSessionCookie = JSON.parse(Cookies.get("session"))
  return (jsonSessionCookie.jwt !== undefined
      && jsonSessionCookie.jwt !== 'undefined'
      && jsonSessionCookie?.jwt?.length > 0);

}

export const getSessionCookie = () => {
  const sessionCookie = Cookies.get("session");
  if (sessionCookie === undefined || sessionCookie === 'undefined') {
    return {};
  } else {
    return JSON.parse(sessionCookie);
  }
};


export const SessionContext = React.createContext({
  session: getSessionCookie(),
  refreshSession:  () => {}
});
